// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"mainContent___1_-y4","mainContentBorder":"mainContentBorder___31bAL"};